import { createReducer, on } from '@ngrx/store';
import { updateScreenerData } from './osma-screener.actions';

export interface OSMAScreenerState {
  data: Record<string, any>;
  loading: boolean;
  error?: any;
}

export const initialState: OSMAScreenerState = {
  data: {},
  loading: false,
};

export const osmaScreenerReducer = createReducer(
  initialState,
  on(updateScreenerData, (state, { advisor, client, accounts, asset }) => ({
    ...state,
    data: {
      ...state.data,
      riskScreenerData: { advisor, client, accounts, asset },
    },
  }))
);
